document.addEventListener('DOMContentLoaded', function() {
  // Function to check if this is a hockey jersey
  function isHockeyJersey() {
    // Check product tags
    const productTagsMeta = document.querySelector('meta[property="og:product:tag"]');
    if (!productTagsMeta) return false;
    
    const productTags = productTagsMeta.getAttribute('content');
    
    // If it doesn't have size chart tags, it's a hockey jersey
    return !(productTags.includes('size-chart-youth') || productTags.includes('size-chart-adult'));
  }
  
  // If this is a hockey jersey, hide all size chart links
  if (isHockeyJersey()) {
    // Find the size chart modal opener and hide it
    const sizeChartOpeners = document.querySelectorAll('.size-chart-link, [data-modal^="size-chart-"]');
    sizeChartOpeners.forEach(opener => {
      // Find the closest parent that contains both the label and size chart
      const container = opener.closest('.flex.justify-between');
      if (container) {
        // If we found the container, we hide just the size chart part
        opener.style.display = 'none';
      }
    });
  }
});